import { jsx } from "react/jsx-runtime";
import { Box, styled, useTheme } from "@mui/material";
import { useMemo } from "react";
function useStyles(props) {
  const { align = "left", gap = 2, padding = 1, sx } = props;
  const { spacing } = useTheme();
  return useMemo(() => {
    let alignment = "flex-start";
    switch (align) {
      case "left":
        alignment = "flex-start";
        break;
      case "center":
        alignment = "space-around";
        break;
      case "right":
        alignment = "right";
        break;
    }
    return {
      ...sx,
      "--form-footer-gap": spacing(gap),
      "--form-footer-padding": spacing(padding),
      "--form-footer-alignment": alignment
    };
  }, [sx, spacing, align, gap, padding]);
}
const Footer = styled(Box, {
  name: "FormFooter",
  slot: "Root"
})(() => ({
  gap: "var(--form-footer-gap)",
  display: "flex",
  padding: "var(--form-footer-padding)",
  flexDirection: "row",
  justifyContent: "var(--form-footer-alignment)"
}));
function FormFooter(props) {
  const { children, testId = "form-footer-root", className, ...styleProps } = props;
  const sx = useStyles(styleProps);
  return /* @__PURE__ */ jsx(Footer, { sx, "data-testid": testId, className, component: "footer", children });
}
export {
  FormFooter
};
//# sourceMappingURL=FormFooter.js.map
